import Dashboard from './components/Dashboard.vue'
import Profiles from './components/Profiles.vue'
import Profile from './components/Profile.vue'
import Heroes from './components/Heroes.vue'
import Items from './components/Items.vue'

export const routes = [
  { path: '/', name: 'Dashboard', component: Dashboard },
  { path: '/profiles', name: 'Profiles', component: Profiles },
  { path: '/profile/:profile_id', name: 'Profile', component: Profile },
  { path: '/heroes', name: 'Heroes', component: Heroes },
  { path: '/items', name: 'Items', component: Items }
]
